export const AZURE_DEVOPS_ORGANIZATION = 'circlet';
export const AZURE_DEVOPS_BASE_URL = `https://dev.azure.com/${AZURE_DEVOPS_ORGANIZATION}`;
export const AZURE_DEVOPS_GRAPH_URL = `https://vssps.dev.azure.com/${AZURE_DEVOPS_ORGANIZATION}`;
export const AZURE_DEVOPS_API_VERSION = '7.1';
export const AZURE_DEVOPS_RESOURCE_SCOPE =
  '499b84ac-1321-427f-aa17-267ca6975798/.default';

export const AZURE_DEVOPS_SCHEDULING_FIELDS = [
  'Microsoft.VSTS.Scheduling.StartDate',
  'Microsoft.VSTS.Scheduling.DueDate',
  'Microsoft.VSTS.Scheduling.FinishDate',
  'Microsoft.VSTS.Scheduling.TargetDate',
  'Microsoft.VSTS.Scheduling.OriginalEstimate',
  'Microsoft.VSTS.Scheduling.RemainingWork',
  'Microsoft.VSTS.Scheduling.CompletedWork',
  'Microsoft.VSTS.Scheduling.StoryPoints'
] as const;

export interface AzureDevOpsPagedResult<T> {
  items: T[];
  continuationToken: string | null;
}

export interface AzureDevOpsProject {
  id: string;
  name: string;
  description: string | null;
  url: string | null;
  state: string | null;
  revision: number | null;
  visibility: string | null;
  lastUpdateTime: string | null;
}

export interface AzureDevOpsWorkItemType {
  name: string;
  referenceName: string;
  description: string | null;
  color: string | null;
  iconUrl: string | null;
}

export interface AzureDevOpsWorkItemState {
  name: string;
  color: string | null;
  category: string | null;
  order: number | null;
}

export interface AzureDevOpsIdentity {
  id: string;
  descriptor: string | null;
  displayName: string;
  mail: string | null;
  principalName: string | null;
  imageUrl: string | null;
  origin: string | null;
}

export type AzureDevOpsFieldValue =
  | string
  | number
  | boolean
  | null
  | AzureDevOpsIdentity;

export interface AzureDevOpsWorkItemRelation {
  rel: string;
  url: string;
  attributes: Readonly<Record<string, unknown>>;
}

export interface AzureDevOpsWorkItem {
  id: number;
  rev: number;
  fields: Readonly<Record<string, unknown>>;
  relations: AzureDevOpsWorkItemRelation[];
  url: string;
  webUrl: string | null;
}

export interface AzureDevOpsWorkItemField {
  referenceName: string;
  name: string;
  type: string | null;
  description: string | null;
  readOnly: boolean;
  required: boolean;
  allowedValues: unknown[];
}

export interface AzureDevOpsComment {
  id: number;
  text: string;
  createdBy: AzureDevOpsIdentity | null;
  createdDate: string;
  modifiedDate: string | null;
}

export interface AzureDevOpsWorkItemUpdate {
  id: number;
  revision: number;
  revisedBy: AzureDevOpsIdentity | null;
  revisedDate: string | null;
  fields: Readonly<Record<string, unknown>>;
  relations: Readonly<Record<string, unknown>>;
}

export interface AzureDevOpsClassificationNode {
  id: number;
  identifier: string | null;
  name: string;
  path: string;
  structureType: 'area' | 'iteration';
  hasChildren: boolean;
  attributes: {
    startDate: string | null;
    finishDate: string | null;
    timeFrame: string | null;
  };
  children: AzureDevOpsClassificationNode[];
}

export interface AzureDevOpsAttachment {
  id: string;
  url: string;
  name: string;
}

export interface AzureDevOpsWiqlResult {
  queryType: string | null;
  asOf: string | null;
  workItemIds: number[];
  relations: Array<{
    sourceId: number | null;
    targetId: number | null;
    rel: string | null;
  }>;
}

export interface CreateAzureDevOpsWorkItemInput {
  project: string;
  type: string;
  title: string;
  description?: string;
  fields?: Readonly<Record<string, AzureDevOpsFieldValue>>;
  parentId?: number;
}

export interface UpdateAzureDevOpsWorkItemInput {
  id: number;
  expectedRevision: number;
  project?: string;
  fields?: Readonly<Record<string, AzureDevOpsFieldValue>>;
  relations?: readonly AzureDevOpsRelationChange[];
}

export type AzureDevOpsRelationChange =
  | { kind: 'add'; rel: string; url: string; comment?: string }
  | { kind: 'remove'; index: number };

export interface AzureDevOpsClientOptions {
  getAccessToken: () => Promise<string>;
  fetch?: typeof fetch;
  timeoutMs?: number;
}
